import { TiktokEventBody } from '../models/tiktok-event-body.model';
import { TiktokEvent } from '../models/tiktok-event.model';
import { TiktokEventType } from '../models/tiktok-event-type.model';
import { EventProductTiktok } from '../models/event-product.model';

export class BaseEventTiktok implements TiktokEvent {
    public eventType: TiktokEventType;
    private product: EventProductTiktok;

    constructor(pageType: TiktokEventType, product: EventProductTiktok) {
        this.eventType = pageType;
        this.product = product;
    }

    getEvent(): TiktokEventBody {
        return {
            value: this.product.price,
            currency: this.product.currency,
            contents: [{
                content_id: `${this.product.id}`,
                content_type: this.product.type,
                content_name: this.product.name,
            }],
        };
    }
}
